import { makeStyles } from "@mui/styles";

import { EconomicsListContainer } from "./EconomicsListContainer";
import { EconomicsSidePanel } from "./EconomicsSidePanel";
import { Economics } from "../components/Economics";
import { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectEconomics } from "../reducers/economicsSlice";
import { selectUser } from "../reducers/userSlice";
import { CircularProgress, IconButton, Typography } from "@mui/material";
import { Cancel } from "@mui/icons-material";

const useStyles = makeStyles(theme => ({
  root: {
    position: 'absolute',
    backgroundColor: theme.palette.grey[100],
    border: 0,
    color: 'text.primary',
    height: '100vh',
    width: 'calc(100% - 60px)',
    paddingTop: 30,
    marginLeft: 60,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
  },
}));


export const EconomicsContainer = () => {
  
  const classes = useStyles();
  const dispatch = useDispatch();

  if (document.title !== ('Economics | SSD')) document.title = ('Economics | SSD');
  
  const user = useSelector(selectUser);
  const economics = useSelector(selectEconomics);
  const currentEconomics = economics?.byId?.[economics?.currentEconomicsId];

  const darkMode = user?.value?.darkMode;

  const [isLoading, setIsLoading] = useState(false);

  const [economicsSettings, setEconomicsSettings] = useState(currentEconomics?.settings);

  // useEffect(() => {
  //   if (user?.value?.email && !economics?.allIds?.length > 0) getUserEconomics(user?.value?.email);

  //   function getUserEconomics(email) {
  //     try {
  //       setIsLoading(true);
  //       dispatch(getEconomics(email)).then(res => {
  //         setIsLoading(false);
  //       });
  //     } catch (error) {
  //       console.log(error);
  //       setIsLoading(false);
  //       return;
  //     };
  //   };
  // }, [dispatch, economics?.allIds, user?.value?.email]);

  const economicsListContainerMemo = useMemo(() => <EconomicsListContainer />, []);
  const economicsSidePanelMemo = useMemo(() => <EconomicsSidePanel economicsSettings={economicsSettings} setEconomicsSettings={setEconomicsSettings} />, [economicsSettings]);
  const economicsMemo = useMemo(() => <Economics />, []);
  
  if (user?.value?.subscription === 'SSD' && !user?.value?.forecastAccess) {
    return (
      <div style={{width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
        <Typography>Please add subscription to your account</Typography>
      </div>
    );
  } else {
    return (
      <div className={classes.root}>
        {isLoading ?
        <div style={{backgroundColor: darkMode ? 'rgba(0, 0, 0, 0.75)' : 'rgba(255, 255, 255, 0.75)', position: 'absolute', left: 0, top: 0, zIndex: 420, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%'}}>
          <Typography style={{marginBottom: 20}}>Calculating economics...</Typography>
          <CircularProgress></CircularProgress>
          <IconButton style={{position: 'absolute', bottom: '60px'}} onClick={() => dispatch(setIsLoading(false))}><Cancel color="grey" /> </IconButton>
        </div>
        :
        <>
          {economicsListContainerMemo}
          {economicsSidePanelMemo}
          {economicsMemo}
          {/* <EconomicsListContainer />
          <EconomicsSidePanel economicsSettings={economicsSettings} setEconomicsSettings={setEconomicsSettings} />
          <Economics /> */}
        </>}
      </div>
    );
  };

};
